import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from '../types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M20.9999 3H2.99988C1.89988 3 0.999878 3.9 0.999878 5V19C0.999878 20.1 1.89988 21 2.99988 21H20.9999C22.0999 21 22.9999 20.1 22.9999 19V5C22.9999 3.9 22.0999 3 20.9999 3ZM20.9999 19.01H2.99988V4.99H20.9999V19.01ZM8.20673 12L6.08541 14.1213L7.49962 15.5355L11.0352 12L7.49962 8.46447L6.08541 9.87868L8.20673 12ZM17.9126 9.87868L15.7913 12L17.9126 14.1213L16.4984 15.5355L12.9629 12L16.4984 8.46447L17.9126 9.87868Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.50006 4.06506C3.25981 4.06506 3.06506 4.25981 3.06506 4.50006V11.5001C3.06506 11.7403 3.25981 11.9351 3.50006 11.9351H12.5001C12.7403 11.9351 12.9351 11.7403 12.9351 11.5001V4.50006C12.9351 4.25981 12.7403 4.06506 12.5001 4.06506H3.50006ZM1.93506 4.50006C1.93506 3.63573 2.63573 2.93506 3.50006 2.93506H12.5001C13.3644 2.93506 14.0651 3.63573 14.0651 4.50006V11.5001C14.0651 12.3644 13.3644 13.0651 12.5001 13.0651H3.50006C2.63573 13.0651 1.93506 12.3644 1.93506 11.5001V4.50006ZM6.12131 8L5.06065 6.93934C4.86539 6.74408 4.86539 6.4275 5.06065 6.23223C5.25591 6.03697 5.57249 6.03697 5.76776 6.23223L7.04055 7.50503C7.31391 7.77839 7.31391 8.22161 7.04055 8.49497L5.76776 9.76777C5.57249 9.96303 5.25591 9.96303 5.06065 9.76777C4.86539 9.5725 4.86539 9.25592 5.06065 9.06066L6.12131 8ZM10.7677 6.93934L9.70706 8L10.7677 9.06066C10.963 9.25592 10.963 9.5725 10.7677 9.76777C10.5725 9.96303 10.2559 9.96303 10.0606 9.76777L8.78782 8.49497C8.51445 8.22161 8.51445 7.77839 8.78782 7.50503L10.0606 6.23223C10.2559 6.03697 10.5725 6.03697 10.7677 6.23223C10.963 6.4275 10.963 6.74408 10.7677 6.93934Z"
  />
);

export const ColumnCollapseIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="ColumnCollapse" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
